import { useLiveQuery } from 'dexie-react-hooks'
import { Dialog } from '../../components/Dialog'
import { Icon } from '../../components/Icon'
import { db } from '../../db/db'
import { userName } from '../../lib/channels'
import { formatDateTime } from '../../lib/format'
import { canPinIn } from '../../lib/posting'
import { useConversation } from './ConversationContext'
import { unpinMessage } from './messageActions'
import { replySummary } from './ReplyQuote'

export function PinnedDrawer({ open, onClose, onJump }: { open: boolean; onClose: () => void; onJump: (id: string, seq?: number) => void }) {
  const { channel, users, me } = useConversation()
  const ids = channel.pinnedMessageIds
  const pinned = useLiveQuery(() => db.messages.bulkGet(ids), [ids.join(',')], [])
  // In a restricted channel only owners and posters pin and unpin.
  const canAct = canPinIn(channel)

  return (
    <Dialog open={open} onClose={onClose} title="Pinned messages" titleId="pinned-title" className="drawer" closeLabel="Close pinned messages">
      <div className="drawer-content">
        {ids.length === 0 ? (
          <div className="empty-state">
            <Icon name="pin" />
            <strong>No pinned messages</strong>
            <p>Pin important messages from the message menu so everyone can find them.</p>
          </div>
        ) : (
          <div className="pinned-list">
            {ids
              .map((id, i) => ({ id, message: pinned[i] }))
              .reverse()
              .map(({ id, message }) => (
                <div key={id}>
                  <button type="button" className="pinned-item" onClick={() => onJump(id, message?.seq)}>
                    <strong>
                      <span>{message ? (message.authorId === me.id ? 'You' : userName(users, message.authorId)) : 'Older message'}</span>
                      {message ? <time dateTime={message.createdAt}>{formatDateTime(message.createdAt)}</time> : null}
                    </strong>
                    <p>{message ? replySummary(message) : 'Not stored on this device yet. Open to load it.'}</p>
                  </button>
                  {canAct ? (
                    <button type="button" className="text-button" onClick={() => void unpinMessage(id)}>
                      Unpin
                    </button>
                  ) : null}
                </div>
              ))}
          </div>
        )}
      </div>
    </Dialog>
  )
}
